import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import CopyInput from "V2.0/common/CopyInput";

export default function APIKeyCopy(props) {
  const { onClose, apiKey } = props;

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>API Key</DialogTitle>
      <DialogBody>
        <div className="space-y-4">
          <p className="text-sm text-gray-500">
            Once Copied, please note that it won't be visible again. If the
            secret key is lost, generating a new one will be required.
          </p>
          <div className="">
            <CopyInput
              value={apiKey}
              title="Key"
            />
          </div>
        </div>
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
